<template>
    <div>
        <BaseTrend :active-index="1"></BaseTrend>
    </div>
</template>

<script>
import BaseTrend from '../components/BaseTrend.vue';
export default {
    components: {
        BaseTrend
    }
}
</script>